import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	feedbackSubmittedFlagTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	feedbackSubmittedFlagDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	feedbackSubmittedFlagDescriptionAppify: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	feedbackSubmittedFlagTitle: {
		id: 'atlassian-intelligence.services.feedback.feedback-submitted-flag-title',
		defaultMessage: 'Thank you for sharing your query',
		description:
			'Title for a success flag displayed to the user when their feedback has been submitted',
	},
	feedbackSubmittedFlagDescription: {
		id: 'atlassian-intelligence.services.feedback.feedback-submitted-flag-description',
		defaultMessage: 'Your valuable feedback helps us continually improve our products.',
		description:
			'Description for a success flag displayed to the user when their feedback has been submitted',
	},
	feedbackSubmittedFlagDescriptionAppify: {
		id: 'atlassian-intelligence.services.feedback.feedback-submitted-flag-description-appify',
		defaultMessage: 'Your valuable feedback helps us continually improve our apps.',
		description:
			'Description for a success flag displayed to the user when their feedback has been submitted',
	},
});
export default messages;
